<template>
  <div style="overflow-x: auto">
    <h5 class="mb-2 mt-4">
      Участники
    </h5>
    <div class="container">
      <div class="row" v-if="showEventData">
        <div  v-for="team in showEventData.teams" :key="'teams-event-data-' + team.team_id ">
          <div v-if="host.hash == team.hash" class="mr-5 ">
            <h5 class="mb-4 mt-4">Команда: {{ team.info?.name }} Slot: {{ team.slot_number }}</h5>
            <table class="table">
              <thead>
              <tr>
                <th scope="col" class="p-0" style="width: 140px">Nick</th>
                <th scope="col" class="p-0">Kill</th>
                <th scope="col" class="p-0">Up</th>
                <th scope="col" class="p-0">Down</th>
                <th scope="col" class="p-0">Жив</th>
              </tr>
              </thead>
              <tbody>
              <RowInHostsBook :disabled="showEventData?.type === 'ended'"
                              v-for="member in team.members"
                              :key="member.id"
                              :member="member"
                              :selected-match="selectedMatch"
                              :team="team"
                              :pending="pendingByMember[member.user_id]"
                              @update-pending="updatePending"
              />
              </tbody>
            </table>
            <div class="d-flex flex-wrap mt-2">
              <b-btn class="mr-2 mb-2"
                     v-b-modal="'deathTeam' + team.team_id"
                     :disabled="showEventData?.type === 'ended'"
                     @click="teamNotEnterToLobby(team)"
              >
                Не вошла
              </b-btn>
              <b-btn variant="primary"
                     class="mb-2"
                     :disabled="!hasPendingChanges(team) || sendingTeamId === team.team_id || showEventData?.type === 'ended'"
                     @click.prevent="sendTeam(team)"
              >
                Send
              </b-btn>
            </div>
          </div>
        </div>

        <b-modal centered
                 id="deathTeamModal"
                 ref="deathTeamModal"
        >
          <p class="my-4">Команда {{ selectedTeam?.info?.name }} точно не вошла?</p>
          <template #modal-footer>
            <div>
              <b-btn variant="primary"
                     class="mr-3"
                     @click="storeAllTeamsWithDeath({
                                     matchId: selectedMatch,
                                     token: selectedTeam?.hash,
                                     teamId: selectedTeam?.team_id});
                                     $refs.deathTeamModal.hide();">
                Да
              </b-btn>
              <b-btn variant="danger" @click="$refs.deathTeamModal.hide();">Отмена</b-btn>
            </div>
          </template>
        </b-modal>
      </div>
      <div v-else-if="!showEventData?.teams" class="loading-wrapper">
        <b-spinner class="spinner"></b-spinner>
      </div>
    </div>
  </div>
</template>
<script>

import {BookAdapterMixin} from "@/mixins/Book/BookAdapterMixin";
import RowInHostsBook from "@/components/Live/RowInHostsBook.vue";

export default {
  name: 'HostsLive',
  components: {RowInHostsBook},
  mixins: [BookAdapterMixin],
  props: {
    host: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      striped: true,
      bordered: true,
      selectedTeam: {},
      pendingByMember: {},
      sendingTeamId: null,
    }
  },
  watch: {
    'showEventData.teams': {
      immediate: true,
      handler(teams) {
        if (!teams) return
        teams.forEach((team) => {
          team.members?.forEach((member) => {
            if (!this.pendingByMember[member.user_id]) {
              this.$set(this.pendingByMember, member.user_id, {
                killDelta: 0,
                death: member.death || 0,
              })
            }
          })
        })
      },
    },
  },
  methods: {
    teamNotEnterToLobby(team) {
      this.selectedTeam = team;
      this.$refs.deathTeamModal.show();
    },
    updatePending({userId, killDelta, death}) {
      this.$set(this.pendingByMember, userId, {killDelta, death})
    },
    hasPendingChanges(team) {
      return (team.members || []).some((m) => {
        const p = this.pendingByMember[m.user_id]
        if (!p) return false
        return p.killDelta !== 0 || p.death !== (m.death || 0)
      })
    },
    collectActions(team) {
      return (team.members || [])
          .map((m) => {
            const p = this.pendingByMember[m.user_id]
            if (!p) return null
            if (p.killDelta === 0 && p.death === (m.death || 0)) return null
            return {user_id: m.user_id, kill: p.killDelta, death: p.death}
          })
          .filter(Boolean)
    },
    async sendTeam(team) {
      const actions = this.collectActions(team)
      if (!actions.length) return
      this.sendingTeamId = team.team_id
      try {
        await this.storeKill({
          matchId: this.selectedMatch,
          token: team.hash,
          actions,
        })
        team.members.forEach((m) => {
          const p = this.pendingByMember[m.user_id]
          if (!p) return
          p.killDelta = 0
          p.death = m.death || 0
        })
      } catch (e) {
        // Errors already toasted in the store action; keep pending state so the user can retry.
      } finally {
        this.sendingTeamId = null
      }
    },
  },
}
</script>
